import React, { Component } from 'react'

import * as styles from './offer.module.css'

function Offer ({offer}) {
  return(
    <div className={styles.offer}>
      {offer.offer && 
        <a href={offer.external_url} rel="sponsored" target="_blank"><div className={styles.preview} dangerouslySetInnerHTML={{__html: offer.offer}}></div></a>
      }
      <div className={styles.offer_details}>
        {offer.title && <div className={styles.title}><b>{offer.title}</b></div>}
        {offer.external_url && <div className={styles.a_button}><a href={offer.external_url} rel="sponsored" target="_blank">Check Price</a></div>}
      </div>
    </div>
  )
}


Offer.defaultProps = {
  props: {},
}

export default Offer